export type LabelColor = { name: string, baseColor: string, hoverColor: string, cssVar: string }

export const LABEL_COLORS : Array<LabelColor> = [
	{ name: 'clay', baseColor: '#FED2B2', hoverColor: '#FCBA8A', cssVar: 'var(--color-label-orange)' },
	{ name: 'coral', baseColor: '#F5C1CA', hoverColor: '#F29FAE', cssVar: 'var(--color-label-red)' },
	{ name: 'yellow', baseColor: '#F9F2B4', hoverColor: '#F8ED91', cssVar: 'var(--color-label-yellow)' },
	{ name: 'aqua', baseColor: '#C3F4F2', hoverColor: '#9CEFEA', cssVar: 'var(--color-label-aqua)' },
	{ name: 'blue', baseColor: '#C0D9FF', hoverColor: '#9DC4FF', cssVar: 'var(--color-label-blue)' },
	{ name: 'lilac', baseColor: '#DFD0FF', hoverColor: '#C7AEFD', cssVar: 'var(--color-label-violet)' },
	{ name: 'apple', baseColor: '#D9EEB7', hoverColor: '#CBE79F', cssVar: 'var(--color-label-green)' },
	{ name: 'pink', baseColor: '#F5CDF1', hoverColor: '#F1B6EB', cssVar: 'var(--color-label-pink)' },
	{ name: 'stone', baseColor: '#E8F0FC', hoverColor: '#BFCEE3', cssVar: 'var(--color-label-blue)' },
	{ name: 'silver', baseColor: '#E9E9E9', hoverColor: '#D9D9D9', cssVar: 'var(--color-label-grey)' }
];

export const DEFAULT_LABEL_COLOR : LabelColor = LABEL_COLORS[ 0 ];
